import script from "./ProjectIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectIcon.vue?vue&type=script&setup=true&lang=js"

import "./ProjectIcon.vue?vue&type=style&index=0&id=648978ed&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648978ed"]])

export default __exports__